import React from 'react';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

const Select = ({
  label = 'label',
  placeholder = 'Select an option',
  register,
  errorMessage,
  required = false,
}) => {
  const options = [
    <option value="0">STANDARD BANK</option>,
    <option value="1">ABSA BANK</option>,
    <option value="10">CITIBANK N.A.</option>,
    <option value="11">NEDBANK SWAZILAND</option>,
    <option value="15">PEP BANK (NEDBANK)</option>,
    <option value="16">BOE BANK (NEDBANK)</option>,
    <option value="17">MERCANTILE BANK</option>,
    <option value="20">NBS (NEDBANK)</option>,
    <option value="21">STANDARD CHARTERED BANK</option>,
    <option value="22">HBZ BANK</option>,
    <option value="23">INVESTEC BANK LIMITED</option>,
    <option value="24">SA POST OFFICE</option>,
    <option value="25">STANDARD BANK SWAZILAND</option>,
    <option value="26">U BANK (TEBA)</option>,
    <option value="28">HABIB OVERSEAS BANK</option>,
    <option value="29">LESOTHO BANK</option>,
    <option value="3">FIRST NATIONAL BANK</option>,
    <option value="33">ITHALA(STANDARD BANK)</option>,
    <option value="35">UNIBANK LIMITED</option>,
    <option value="36">RESERVE BANK</option>,
    <option value="37">S.A. BANK OF ATHENS</option>,
    <option value="38">NEDBANK LESOTHO</option>,
    <option value="39">FBC FIDELITY BANK (NEDBANK)</option>,
    <option value="4">AFRICAN BANK</option>,
    <option value="43">GRINDROD BANK</option>,
    <option value="44">CAPITEC BANK</option>,
    <option value="51">NEDBANK NAMIBIA</option>,
    <option value="52">BIDVEST BANK</option>,
    <option value="54">WESBANK</option>,
    <option value="55">TOYOTA FINANCIAL SERVICES</option>,
    <option value="56">
      THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED
    </option>,
    <option value="57">STATE BANK OF INDIA</option>,
    <option value="58">VBS MUTUAL BANK</option>,
    <option value="59">ALBARAKA</option>,
    <option value="6">STANDARD LESOTHO BANK LIMITED</option>,
    <option value="60">JP MORGAN CHASE BANK N.A</option>,
    <option value="61">FINBOND MUTUAL BANK</option>,
    <option value="62">SASFIN BANK LIMITED</option>,
    <option value="63">BNP PARIBAS</option>,
    <option value="64">STANDARD BANK NAMIBIA</option>,
    <option value="65">VOLKSWAGEN FINANCIAL SERVICES</option>,
    <option value="7">NEDBANK</option>,
    <option value="99">OTHER</option>,
  ];

  //   const getOptions = () => {
  //     let arr = [];
  //     for (const key in options) {
  //       arr.push(
  //         <option key={key} value={key}>
  //           {options[key]}
  //         </option>,
  //       );
  //     }
  //     return arr;
  //   };

  return (
    <div className="mb-8">
      <label className="uppercase tracking-widest text-xl" htmlFor="">
        {label}
        {required ? (
          <span className="text-red-500 text-md relative -top-1 left-1">*</span>
        ) : null}
        <select
          className="block h-12 w-full mt-2 px-3 border text-base border-gray-300 bg-black focus:outline-none focus:ring-primary-500 focus:border-primary-500"
          {...register(
            label.toLowerCase().split(' ').join('_').split('/').join('_'),
          )}
        >
          <option value="">{placeholder}</option>
          {options.map((item) => item)}
        </select>
      </label>
      <ErrorMessage message={errorMessage} />
    </div>
  );
};

export default Select;
